import { CirclePacking, CirclePackingZoomBox } from '../../../models/circlePackingModel';

export const bounds: (circles: Array<CirclePacking>) => CirclePackingZoomBox = (circle) => getCirclesBox(circle as Array<CirclePacking>);

const getCirclesBox: (circles: Array<CirclePacking>) => CirclePackingZoomBox = (circles) => {
  //  Given an array of circles, we want to calculate its bounds
  //  we use reduce to iterate through each circle and get
  //  the enclosing square based on the circle coordinates
  const circlesBounds = circles.reduce(
    (next, circle) => {
      const x = circle.x;
      const y = circle.y;
      const r = circle.r;

      //  Based on its position and radius we calculate its boundaries
      const current = {
        left: x - r,
        right: x + r,
        top: y - r,
        bottom: y + r
      };

      return {
        left: Math.min(next.left, current.left),
        right: Math.max(next.right, current.right),
        top: Math.min(next.top, current.top),
        bottom: Math.max(next.bottom, current.bottom)
      };
    },
    {
      left: Number.MAX_VALUE,
      right: Number.MIN_VALUE,
      top: Number.MAX_VALUE,
      bottom: Number.MIN_VALUE
    }
  );
  return {
    x: circlesBounds.left,
    y: circlesBounds.top,
    width: circlesBounds.right - circlesBounds.left,
    height: circlesBounds.bottom - circlesBounds.top
  };
};
